import { DocTop } from '@/components/shell/DocTop';
import { DocsView } from '@/components/DocsView';

/** `/ghid` — the operator manual, wrapped in the standard page shell
 *  (`DocTop`, like every other `AppShell` page). `DocsView` renders its own
 *  `<h1>` + two-column (sticky ToC + content) body below it, at the shared
 *  `PageCanvas` document measure `AppShell` now applies around every route. */
export function GhidPage() {
  return (
    <>
      <DocTop />
      <DocsView />
    </>
  );
}
